import { CardUIExtension, ICardUIExtensionContext, ICardModel } from 'tessa/ui/cards';
import { Guid, createTypedField, DotNetType, Visibility } from 'tessa/platform';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { CdUIHelper } from '../CdUIHelper';
import { CardPermissionFlags, CardRow, CardRowState } from 'tessa/cards';
import { GridRowAction, GridViewModel } from 'tessa/ui/cards/controls';
import { reaction } from 'mobx';
import { userSession } from 'common/utility';

export class CdPersonalRoleUIExtension extends CardUIExtension {

  private _disposer: Function | null = null;

  public initialized(context: ICardUIExtensionContext) {
    let model: ICardModel;
    if (context == null ||
      (model = context.model) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PersonalRoleTypeID)) {
      return;
    }

    this.InitializePkLegalEntitiesControl(model, context);
    this.HideHint(context);
    this.SetDefaultValue(context);
  }

  private HideHint(context: ICardUIExtensionContext) {
    const hintControlModel = context.model.controls.get("AccessAdminHint");
    if (hintControlModel == null) return;

    if (!userSession.isAdmin) {
      hintControlModel.controlVisibility = Visibility.Collapsed;
    }
    else {
      hintControlModel.controlVisibility = Visibility.Visible;
    }
  }

  /** Инициализация таблички "Организации". */
  private InitializePkLegalEntitiesControl(model: ICardModel, context: ICardUIExtensionContext) {
    const pkLegalEntitiesControl = CdUIHelper
      .GetUIControlFromModel<GridViewModel>(model, "PkLegalEntitiesControl");

    if (pkLegalEntitiesControl == null) {
      return;
    }

    if (this._disposer == null) {
      this._disposer = reaction(() => pkLegalEntitiesControl.selectedRows, () => {
        this.PkLegalEntitiesControlSelectedRowHandle(context, pkLegalEntitiesControl);
      });
    }

    pkLegalEntitiesControl.rowAdding.add((e) => {
      e.row.set("IsManuallyAdded", createTypedField(true, DotNetType.Boolean));
    });

    pkLegalEntitiesControl.rowInitializing.add((e) => {
      this.EntityControlHandle(e.row, e.rowModel!);
    });
  }

  /** Обработка контрола организации. */
  private PkLegalEntitiesControlSelectedRowHandle(context: ICardUIExtensionContext, pkLegalEntitiesControl: GridViewModel) {
    // проверяем есть ли выделенная строка
    if (pkLegalEntitiesControl.selectedRow == null) {
      return;
    }

    // получаем флаг из выделенной строки
    const isManuallyAdded = pkLegalEntitiesControl.selectedRow.row.tryGet("IsManuallyAdded");

    // получаем права доступа по флагу
    const rowPermissions = isManuallyAdded
      ? CardPermissionFlags.AllowDeleteRow
      : CardPermissionFlags.ProhibitDeleteRow;

    // задаем права доступа
    context.model.card.permissions.sections
      .getOrAdd("PkLegalEntitiesVirtual")
      .setSectionPermissions(rowPermissions);
  }

  /** Обработка контрола "Организация". */
  private EntityControlHandle(row: CardRow, rowModel: ICardModel) {
    const entityInTableControl = rowModel.controls.get("EntityInTableControl");
    const isManuallyAdded = row.tryGet("IsManuallyAdded") === true;
    if (entityInTableControl != null) {
      entityInTableControl.isReadOnly = !isManuallyAdded;
    }
  }

  public finalized() {
    // подчищаем за собой
    if (this._disposer) {
      this._disposer();
      this._disposer = null;
    }
  }

  /** Предзаполняет табличную часть значениями по умолчанию */
  private SetDefaultValue(context: ICardUIExtensionContext) {
    let roleDeputiesManagement = CdUIHelper.GetUIControl<GridViewModel>(context, "RoleDeputiesManagement");

    if (roleDeputiesManagement == null) {
      return;
    }

    roleDeputiesManagement.rowInvoked.add(e => {
      if (e.rowModel != null && e.action === GridRowAction.Inserted) {
        let roleDeputiesManagementRolesSection = e.cardModel.card.sections.tryGet('RoleDeputiesManagementRolesVirtual');
        if (!roleDeputiesManagementRolesSection) return;

        let newCardRow: CardRow = new CardRow();
        newCardRow.rowId = Guid.newGuid();
        newCardRow.set("RoleID", "c89c715b-11cd-4f96-a0bf-103ffd4dfad9", DotNetType.Guid);
        newCardRow.set("RoleName", "$Views_AvailableDeputyRoles_AllRolesAndDepartments_Sql", DotNetType.String);
        newCardRow.set("ParentRowID", e.row.rowId, DotNetType.Guid);
        newCardRow.state = CardRowState.Inserted;
        roleDeputiesManagementRolesSection.rows.add(newCardRow);
      }
    });
  }
}